/**
 * Created by chenguangjun on 2016/9/1.
 */

export default class cookieHandle {  // To handle a cookie
  constructor (key) {
    this.key = key.toString();
    this.content = this.get();  // If the cookie exists, get the content. Otherwise, leave it null.
    return this.content;
  }

  // validTime is millisecond
  set (content, validTime = 360 * 24 * 60 * 60 * 1000) {              // Set cookie
    if (typeof parseInt(validTime) !== 'number' || validTime < 0) {   // Restrict
      validTime = 360 * 24 * 60 * 60 * 1000;  // Available for 360 days
    }
    let expireTime = new Date(Date.now() + validTime);

    document.cookie = `${this.key}=${encodeURIComponent(content)};expires=${expireTime.toGMTString()}`;

    this.content = content;
  }

  get (key = this.key) {
    let r = null;
    if (document.cookie.length > 0) {
      let cookieArray = document.cookie.split(';');
      for (let cookie of cookieArray) {
        if (cookie.includes(`${key}=`)) {
          let temp = cookie.split('=');
          r = temp[1];
        }
      }
    }
    return r;
  }

  static remove (key = this.key) {
    if (document.cookie.length > 0) {
      document.cookie = `${key}=;expires=${(new Date(0)).toGMTString()}`;
      this.content = null;
    }
  }

  toString () {
    return `${this.key}=${this.content}`;
  }
}



// WEBPACK FOOTER //
// ./src/gadgets/cookieHandler.js